import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { Button, Paper } from '@mui/material';

import { loginRequest } from './msalConfig';
import { authService } from '../../services/auth.service';

const LoginButton: React.FC = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  const onClickLogin = async (isPopup: boolean = true) => {
    try {
      
      if (isPopup) {
        const response = await instance.loginPopup({ scopes: loginRequest.scopes });
        if (response.account) instance.setActiveAccount(response.account);
        navigate("/plannen");
      } 
      else {
        await instance.loginRedirect({ scopes: loginRequest.scopes });
      }

    } 
    catch (error) {
      console.error("Login failed!", error);
    }
  };

  return (
    <Paper sx={{ width: "500px", padding: "55px 30px 35px", margin: "0px auto" }}>
      <p>
        Om infraplannen.nl te gebruiken is een Microsoft account vereist.
        Door gebruik te maken van infraplannen.nl gaat u akkoord met de{" "}
        <a href="/algemene-voorwaarden" target="_blank" rel="noreferrer">algemene voorwaarden</a> en{" "}
        <a href="/privacy" target="_blank" rel="noreferrer">privacyverklaring</a>.
      </p>

      <Button variant="contained" color="secondary" onClick={() => onClickLogin(true)}>
        Inloggen
      </Button>

      <p className="note">
        Opent de Microsoft login niet? <br />
        <a onClick={() => onClickLogin(false)}>Log dan in via deze link.</a>
      </p>
    </Paper>
  );
};

export default LoginButton;
